import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  useRecoilState,
  useRecoilValueLoadable,
  useSetRecoilState
} from 'recoil';
import {
  Drawer,
  Avatar,
  Tooltip,
  DatePicker,
  Upload,
  InputNumber,
  Switch,
  Collapse,
  Image,
  Button,
  Select,
  Input,
  notification
} from 'antd';
import { Comment } from '@ant-design/compatible';
import {
  InboxOutlined,
  CloseOutlined
} from '@ant-design/icons';
import moment from 'moment';
import dayjs from 'dayjs';
import Grocefy from '../../../../assets/images/grocefyLogoAlone.png';
import {
  refreshPromoEmailsAtom,
  selectedPromoEmailAtom,
  showRelatedItemPickAtom,
  selectedPickingItemAtom
} from '../../../../atoms/Atoms';
import { businessesSelector } from '../../../../atoms/Selectors';
import api from '../../../../api/api';

function EditPromoEmailDrawer() {
  const { Dragger } = Upload;
  const { Panel } = Collapse;
  const { TextArea } = Input;
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const businesses = useRecoilValueLoadable(businessesSelector);
  const setShowRelatedItemPick = useSetRecoilState(showRelatedItemPickAtom);
  const setRefreshPromoEmails = useSetRecoilState(refreshPromoEmailsAtom);
  const [selectedPickingItem, setSelectedPickingItem] =
    useRecoilState(selectedPickingItemAtom);
  const [selectedPromoEmail, setSelectedPromoEmail] = useRecoilState(selectedPromoEmailAtom);
  const [loading, setLoading] = useState(false);
  const [promoEmail, setPromoEmail] = useState({});
  const [headerImageEnglishData, setHeaderImageEnglishData] = useState(null);
  const [headerImageSpanishData, setHeaderImageSpanishData] = useState(null);
  const [mainImageEnglishData, setMainImageEnglishData] = useState(null);
  const [mainImageSpanishData, setMainImageSpanishData] = useState(null);
  const [footerImageEnglishData, setFooterImageEnglishData] = useState(null);
  const [footerImageSpanishData, setFooterImageSpanishData] = useState(null);
  const [relatedItem, setRelatedItem] = useState(null);
  const { t } = useTranslation();

  const englishHeaderDraggerProps = {
    name: 'file',
    accept: 'image/*',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      setHeaderImageEnglishData(file);
      return false;
    }
  };
  const spanishHeaderDraggerProps = {
    name: 'file',
    accept: 'image/*',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      setHeaderImageSpanishData(file);
      return false;
    }
  };
  const englishMainDraggerProps = {
    name: 'file',
    accept: 'image/*',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      setMainImageEnglishData(file);
      return false;
    }
  };
  const spanishMainDraggerProps = {
    name: 'file',
    accept: 'image/*',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      setMainImageSpanishData(file);
      return false;
    }
  };
  const englishFooterDraggerProps = {
    name: 'file',
    accept: 'image/*',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      setFooterImageEnglishData(file);
      return false;
    }
  };
  const spanishFooterDraggerProps = {
    name: 'file',
    accept: 'image/*',
    multiple: false,
    showUploadList: false,
    beforeUpload: (file) => {
      setFooterImageSpanishData(file);
      return false;
    }
  };

  const showMessage = function (message) {
    notification.open({
      message: '',
      description: (
        <Comment
          author={<span>Grocefy</span>}
          avatar={<Avatar src={Grocefy} alt="grocefy" />}
          content={
            <p className="text-sm">
              {message}
            </p>
          }
          datetime={
            <Tooltip title={moment().format('YYYY-MM-DD HH:mm:ss')}>
              <span>{moment().fromNow()}</span>
            </Tooltip>
          }
        />
      ),
    });
  };

  const uploadImage = async function (imageData) {
    const file = imageData;
    const boundary = Date.now();
    const data = new FormData();
    data.append('file', file);
    setLoading(true);
    const response = await api
      .post('utility/promoEmail/uploadfile', data);
    setLoading(false);
    if (response.data.success) {
      return response.data.data;
    }
    showMessage(response.data.error);
    return null;
  };

  const getItem = function (itemId) {
    api.get(`businesses/catalog/item/${itemId}`)
      .then((response) => {
        if (response.data.success) {
          setRelatedItem(response.data.data);
        } else {
          console.error(response.data.error);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const removeEnlgishHeaderImage = function () {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.headerImageUrlEng = '';
    setPromoEmail(temp);
  };
  const removeSpanishHeaderImage = function () {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.headerImageUrlSpa = '';
    setPromoEmail(temp);
  };
  const removeEnlgishMainImage = function () {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.imageUrlEng = '';
    setPromoEmail(temp);
  };
  const removeSpanishMainImage = function () {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.imageUrlSpa = '';
    setPromoEmail(temp);
  };
  const removeEnlgishFooterImage = function () {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.footerImageUrlEng = '';
    setPromoEmail(temp);
  };
  const removeSpanishFooterImage = function () {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.footerImageUrlSpa = '';
    setPromoEmail(temp);
  };

  const removeRelatedItem = function () {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    setRelatedItem(null);
    temp.relatedItemId = null;
    setPromoEmail(temp);
  };

  const onChangeMaxToSend = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.maxToSend = obj === 0 ? null : obj;
    setPromoEmail(temp);
  };

  const onChangeSendDate = function (date, dateString) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.sendDate = dateString;
    setPromoEmail(temp);
  };

  const onChangeDate = function (date, dateString) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    const start = dateString[0];
    const end = dateString[1];
    temp.startDate = start;
    temp.endDate = end;
    setPromoEmail(temp);
  };

  const onChangeMaxPerUser = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.maxPerUser = obj === 0 ? null : obj;
    setPromoEmail(temp);
  };

  const onChangeStatus = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.status = obj;
    setPromoEmail(temp);
  };

  const onChangeTemplate = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.template = obj;
    setPromoEmail(temp);
  };

  const onChangeIsHtmlBody = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.isHtmlBody = obj;
    setPromoEmail(temp);
  };

  const onChangeIsActive = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.isActive = obj;
    setPromoEmail(temp);
  };

  const onChangeSubjectEng = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.subjectTextEng = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeSubjectSpa = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.subjectTextSpa = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeMessageEng = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.messageEng = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeMessageSpa = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.messageSpa = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeTemplateId = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.templateId = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeTemplateIdSpa = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.templateIdSpa = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeAction = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.action = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeActionTextSpa = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.actionButtonTextSpa = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeActionTextEng = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.actionButtonTextEng = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeItemName = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.name = obj.target.value;
    setPromoEmail(temp);
  };

  const onChangeBusiness = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.relatedBusinessId = obj;
    setPromoEmail(temp);
  };

  const onChangeOrderType = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.orderTypes = obj;
    setPromoEmail(temp);
  };

  const onChangeEmailType = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.types = obj;
    setPromoEmail(temp);
  };

  const onChangeOrderStatus = function (obj) {
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.orderStatusTrigger = obj;
    setPromoEmail(temp);
  };

  const submitPromoEmail = function () {
    setLoading(true);
    const temp = JSON.parse(JSON.stringify(promoEmail));
    temp.type = 0;
    temp.orderType = 0;
    for (let i = 0; i < temp.types.length; i++) {
      temp.type += temp.types[i];
    }
    for (let i = 0; i < temp.orderTypes.length; i++) {
      temp.orderType += temp.orderTypes[i];
    }
    if (temp.sendDate && temp.sendDate.length > 0) {
      temp.sendDate = moment(temp.sendDate);
    }
    if (temp.startDate && temp.startDate.length > 0) {
      temp.startDate = moment(temp.startDate);
    }
    if (temp.endDate && temp.endDate.length > 0) {
      temp.endDate = moment(temp.endDate);
    }
    if (temp.sendDate && temp.sendDate.length > 0 && temp.sendDate.length < 17) {
      temp.sendDate = `${temp.sendDate.replace(' ', 'T')}:00.000`;
    }
    if (temp.startDate && temp.startDate.length > 0 && temp.startDate.length < 17) {
      temp.startDate = `${temp.startDate.replace(' ', 'T')}:00.000`;
    }
    if (temp.endDate && temp.endDate.length > 0 && temp.endDate.length < 17) {
      temp.endDate = `${temp.endDate.replace(' ', 'T')}:00.000`;
    }
    if (temp.types && !temp.types.includes(2) && !temp.types.includes(8)) {
      temp.orderStatusTrigger = undefined;
    }
    if (temp.types && !temp.types.includes(4)) {
      temp.relatedItemId = undefined;
    }
    if (temp.template === 0) {
      temp.action = '';
      temp.actionButtonTextEng = '';
      temp.actionButtonTextSpa = '';
    }
    let url = 'marketing/promotion/emails';
    if (temp.id) {
      url += `/${temp.id}`;
    }
    api.post(
      url,
      temp
    )
      .then((response) => {
        setLoading(false);
        if (response.data.success) {
          setRefreshPromoEmails(true);
          setSelectedPromoEmail(null);
        } else {
          showMessage(response.data.error);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  const archiveClick = function () {
    setLoading(true);
    api.delete(`marketing/promotion/emails/${promoEmail.id}`)
      .then((response) => {
        setLoading(false);
        if (response.data.success) {
          setRefreshPromoEmails(true);
          setSelectedPromoEmail(null);
        } else {
          console.error(response.data.error);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {
    if (selectedPromoEmail) {
      const temp = JSON.parse(JSON.stringify(selectedPromoEmail));
      if (!temp.id) {
        temp.types = [1];
        temp.orderTypes = [1];
        temp.template = 0;
        temp.relatedBusinessId = '';
        temp.orderStatusTrigger = 0;
        temp.isHtmlBody = false;
        temp.isActive = false;
        temp.status = 0;
      }
      if (temp.relatedItemId) {
        getItem(temp.relatedItemId);
      }
      setPromoEmail(temp);
    }
  }, [selectedPromoEmail]);

  useEffect(() => {
    if (selectedPickingItem && promoEmail) {
      const temp = JSON.parse(JSON.stringify(promoEmail));
      setRelatedItem(selectedPickingItem);
      temp.relatedItemId = selectedPickingItem.id;
      setPromoEmail(temp);
      setSelectedPickingItem(null);
    }
  }, [selectedPickingItem]);

  useEffect(async () => {
    if (headerImageEnglishData) {
      const url = await uploadImage(headerImageEnglishData);
      if (url) {
        setHeaderImageEnglishData(null);
        const temp = JSON.parse(JSON.stringify(promoEmail));
        temp.headerImageUrlEng = url;
        setPromoEmail(temp);
      }
    }
  }, [headerImageEnglishData]);

  useEffect(async () => {
    if (headerImageSpanishData) {
      const url = await uploadImage(headerImageSpanishData);
      if (url) {
        setHeaderImageSpanishData(null);
        const temp = JSON.parse(JSON.stringify(promoEmail));
        temp.headerImageUrlSpa = url;
        setPromoEmail(temp);
      }
    }
  }, [headerImageSpanishData]);

  useEffect(async () => {
    if (mainImageEnglishData) {
      const url = await uploadImage(mainImageEnglishData);
      if (url) {
        setMainImageEnglishData(null);
        const temp = JSON.parse(JSON.stringify(promoEmail));
        temp.imageUrlEng = url;
        setPromoEmail(temp);
      }
    }
  }, [mainImageEnglishData]);

  useEffect(async () => {
    if (mainImageSpanishData) {
      const url = await uploadImage(mainImageSpanishData);
      if (url) {
        setMainImageSpanishData(null);
        const temp = JSON.parse(JSON.stringify(promoEmail));
        temp.imageUrlSpa = url;
        setPromoEmail(temp);
      }
    }
  }, [mainImageSpanishData]);

  useEffect(async () => {
    if (footerImageEnglishData) {
      const url = await uploadImage(footerImageEnglishData);
      if (url) {
        setFooterImageEnglishData(null);
        const temp = JSON.parse(JSON.stringify(promoEmail));
        temp.footerImageUrlEng = url;
        setPromoEmail(temp);
      }
    }
  }, [footerImageEnglishData]);

  useEffect(async () => {
    if (footerImageSpanishData) {
      const url = await uploadImage(footerImageSpanishData);
      if (url) {
        setFooterImageSpanishData(null);
        const temp = JSON.parse(JSON.stringify(promoEmail));
        temp.footerImageUrlSpa = url;
        setPromoEmail(temp);
      }
    }
  }, [footerImageSpanishData]);

  return (
    <Drawer
      title={`${promoEmail && promoEmail.id ? t('update') : t('create')} ${t('promo_email')}`}
      placement="right"
      closable
      onClose={() => setSelectedPromoEmail(null)}
      open={selectedPromoEmail}
      width={400}
    >
      {promoEmail && (
        <>
          <div
            style={{
              float: 'right',
              marginBottom: '10px'
            }}
          >
            <Button
              type="primary"
              danger
              disabled={loading}
              hidden={!promoEmail.id}
              onClick={() => { archiveClick(); }}
            >
              {t('archive')}
            </Button>
          </div>
          <div style={{ marginBottom: 10 }}>
            <strong>{t('name')}:</strong>
            <Input
              disabled={loading}
              placeholder="Name"
              onChange={(obj) => onChangeItemName(obj)}
              value={promoEmail.name}
            />
          </div>
          {promoEmail && promoEmail.id && (
            <>
              <div style={{ marginBottom: 10 }}>
                <strong>{t('active')}?</strong>
                <Switch
                  style={{ float: 'right' }}
                  checked={promoEmail.isActive}
                  onChange={(checked) => {
                    onChangeIsActive(checked);
                  }}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong>{t('status')}: </strong>
                <Select
                  hidden={promoEmail.status === 3}
                  defaultValue={promoEmail.status}
                  value={promoEmail.status}
                  style={{ width: 120 }}
                  disabled={loading}
                  onChange={(obj) => onChangeStatus(obj)}
                >
                  <Option value={0}>{t('pending')}</Option>
                  <Option value={1}>{t('approved')}</Option>
                  <Option value={2}>{t('declined')}</Option>
                </Select>
                <Select
                  hidden={promoEmail.status !== 3}
                  defaultValue={3}
                  value={3}
                  style={{ width: 120 }}
                  disabled={loading}
                  onChange={(obj) => onChangeStatus(obj)}
                >
                  <Option value={3}>{t('sent')}</Option>
                </Select>
              </div>
            </>
          )}
          <Collapse defaultActiveKey={['1']}>
            <Panel header="Configuration" key="1">
              <div style={{ marginBottom: 10 }}>
                <strong>{t('email_type')}: </strong>
                <br />
                <Select
                  mode="multiple"
                  allowClear
                  defaultValue={promoEmail.types}
                  value={promoEmail.types}
                  style={{ width: '100%' }}
                  disabled={loading}
                  onChange={(obj) => onChangeEmailType(obj)}
                >
                  <Option
                    value={1}
                    disabled={
                      promoEmail.types &&
                        (promoEmail.types.includes(2) ||
                        promoEmail.types.includes(4) ||
                        promoEmail.types.includes(8))
                    }
                  >
                    {t('broadcast')}
                  </Option>
                  <Option
                    value={2}
                    disabled={!promoEmail.types ||
                      (promoEmail.types && promoEmail.types.includes(1))}
                  >
                    {t('order_submit_specific')}
                  </Option>
                  <Option
                    value={4}
                    disabled={!promoEmail.types ||
                      (promoEmail.types && promoEmail.types.includes(1))}
                  >
                    {t('item_purchase_specific')}
                  </Option>
                  <Option
                    value={8}
                    disabled={!promoEmail.types ||
                      (promoEmail.types && promoEmail.types.includes(1))}
                  >
                    {t('order_status_specific')}
                  </Option>
                </Select>
              </div>
              <div
                style={{ marginBottom: 10 }}
                hidden={!promoEmail.types || !promoEmail.types.includes(2)}
              >
                <strong>{t('order_types')}: </strong>
                <br />
                <Select
                  mode="multiple"
                  allowClear
                  defaultValue={promoEmail.orderTypes}
                  value={promoEmail.orderTypes}
                  style={{ width: '100%' }}
                  disabled={loading}
                  onChange={(obj) => onChangeOrderType(obj)}
                >
                  <Option value={1}>{t('any')}</Option>
                  <Option value={2}>{t('pickup')}</Option>
                  <Option value={4}>{t('delivety')}</Option>
                  <Option value={64}>{t('in_store')}</Option>
                </Select>
              </div>
              <div
                hidden={!promoEmail.types || !promoEmail.types.includes(8)}
                style={{ marginBottom: 10 }}
              >
                <strong>{t('order_status_trigger')}: </strong>
                <Select
                  defaultValue={promoEmail.orderStatusTrigger}
                  value={promoEmail.orderStatusTrigger}
                  style={{ width: 120 }}
                  disabled={loading}
                  onChange={(obj) => onChangeOrderStatus(obj)}
                >
                  <Option value={0}>Placed</Option>
                  <Option value={3}>Accepted</Option>
                  <Option value={16}>Picking Started</Option>
                  <Option value={17}>Picking Finished</Option>
                  <Option value={18}>Packing Started</Option>
                  <Option value={19}>Packing Finished</Option>
                  <Option value={20}>Waiting For Customer Pickup</Option>
                  <Option value={5}>Delivery Started</Option>
                  <Option value={6}>Customer Picked Up</Option>
                  <Option value={7}>Delivered</Option>
                  <Option value={8}>Business Cancelled</Option>
                  <Option value={9}>User Cancelled</Option>
                </Select>
              </div>
              <div
                style={{ marginBottom: 10 }}
                hidden={!promoEmail.types || (promoEmail.types && promoEmail.types.includes(1)) ||
                  promoEmail.types.length === 0}
              >
                <strong>{t('business')}: </strong>
                <Select
                  defaultValue={promoEmail.relatedBusinessId}
                  value={promoEmail.relatedBusinessId}
                  style={{ width: 120 }}
                  disabled={loading}
                  onChange={(obj) => onChangeBusiness(obj)}
                >
                  <Option value="">Any</Option>
                  {businesses.state === 'hasValue' && _.map(businesses.contents.data.data.results, (business) => (
                    <Option
                      value={business.id}
                      key={business.id}
                    >
                      {business.name}
                    </Option>
                  ))}
                </Select>
              </div>
              <div
                style={{ marginBottom: 10 }}
                hidden={!promoEmail.types || (promoEmail.types && promoEmail.types.includes(1)) ||
                  promoEmail.types.length === 0}
              >
                <strong>{t('max_to_sent')}</strong>
                <InputNumber
                  disabled={loading}
                  onChange={(obj) => onChangeMaxToSend(obj)}
                  value={promoEmail.maxToSend}
                />
              </div>
              <div
                style={{ marginBottom: 10 }}
                hidden={!promoEmail.types || (promoEmail.types && promoEmail.types.includes(1)) ||
                  promoEmail.types.length === 0}
              >
                <strong>{t('max_per_user')}</strong>
                <InputNumber
                  disabled={loading}
                  onChange={(obj) => onChangeMaxPerUser(obj)}
                  value={promoEmail.maxPerUser}
                />
              </div>
              <div
                style={{ marginBottom: 10 }}
                hidden={!promoEmail.types || !promoEmail.types.includes(1)}
              >
                <strong>{t('send_date')}</strong>
                <br />
                <DatePicker
                  showTime={{ format: 'HH:mm' }}
                  format="YYYY-MM-DD HH:mm"
                  onChange={(date, dateString) => onChangeSendDate(date, dateString)}
                  defaultValue={
                    !promoEmail.sendDate
                    || promoEmail.sendDate === ''
                    || promoEmail.sendDate === null ?
                      '' : dayjs(selectedPromoEmail.sendDate)
                  }
                />
              </div>
              <div
                style={{ marginBottom: 10 }}
                hidden={!promoEmail.types || promoEmail.types.includes(1)}
              >
                <strong>{t('start_end_date')}</strong>
                <br />
                <RangePicker
                  showTime={{ format: 'HH:mm' }}
                  onChange={
                    (date, dateString) =>
                      onChangeDate(date, dateString)
                  }
                  format="YYYY-MM-DD HH:mm"
                  defaultValue={[
                    dayjs(selectedPromoEmail.startDate),
                    dayjs(selectedPromoEmail.endDate),
                  ]}
                />
              </div>
              <div
                hidden={!promoEmail.types || !promoEmail.types.includes(4)}
                style={{ marginBottom: 10 }}
              >
                <strong>{t('related_item_id')}</strong>
                <br />
                {!promoEmail.relatedItemId && (
                  <Button
                    onClick={() => { setShowRelatedItemPick(true); }}
                  >
                    {t('select_item')}
                  </Button>
                )}
                {promoEmail.relatedItemId && (
                  <>
                    {relatedItem && (
                      <>
                        <img
                          height={50}
                          width={50}
                          alt={`${relatedItem.brand} ${relatedItem.name} ${relatedItem.description}`}
                          src={relatedItem.itemImage}
                        />
                        <span>
                          {relatedItem.brand} {relatedItem.name} {relatedItem.description}
                        </span>
                      </>
                    )}
                    <Button
                      onClick={() => removeRelatedItem()}
                    >
                      {t('delete')}
                    </Button>
                  </>
                )}
              </div>
            </Panel>
            <Panel header="Content" key="2">
              <div style={{ marginBottom: 10 }}>
                <strong>{t('english_subject')}</strong>
                <Input
                  disabled={loading}
                  onChange={(obj) => onChangeSubjectEng(obj)}
                  value={promoEmail.subjectTextEng}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong>{t('spanish_subject')}</strong>
                <Input
                  disabled={loading}
                  onChange={(obj) => onChangeSubjectSpa(obj)}
                  value={promoEmail.subjectTextSpa}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong>{t('template')}: </strong>
                <Select
                  defaultValue={promoEmail.template}
                  value={promoEmail.template}
                  style={{ width: 120 }}
                  disabled={loading}
                  onChange={(obj) => onChangeTemplate(obj)}
                >
                  <Option value={0}>{t('generic')}</Option>
                  <Option value={1}>{t('action_link')}</Option>
                  <Option value={2}>{t('custom')}</Option>
                </Select>
              </div>
              <div
                hidden={promoEmail.template !== 2}
                style={{ marginBottom: 10 }}
              >
                <strong>{t('english_template_id')}:</strong>
                <Input
                  disabled={loading}
                  onChange={(obj) => onChangeTemplateId(obj)}
                  value={promoEmail.templateId}
                />
              </div>
              <div
                hidden={promoEmail.template !== 2}
                style={{ marginBottom: 10 }}
              >
                <strong>{t('spanish_template_id')}:</strong>
                <Input
                  disabled={loading}
                  onChange={(obj) => onChangeTemplateIdSpa(obj)}
                  value={promoEmail.templateIdSpa}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong>{t('english_message')}</strong>
                <TextArea
                  onChange={(obj) => onChangeMessageEng(obj)}
                  rows={4}
                  value={promoEmail.messageEng}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong>{t('spanish_message')}</strong>
                <TextArea
                  onChange={(obj) => onChangeMessageSpa(obj)}
                  rows={4}
                  value={promoEmail.messageSpa}
                />
              </div>
              <div style={{ marginBottom: 10 }}>
                <strong>Is Body Html?</strong>
                <Switch
                  style={{ float: 'right' }}
                  checked={promoEmail.isHtmlBody}
                  onChange={(checked) => {
                    onChangeIsHtmlBody(checked);
                  }}
                />
              </div>
              <div
                hidden={promoEmail.template === 0}
                style={{ marginBottom: 10 }}
              >
                <strong>{t('action_button_spanish')}</strong>
                <Input
                  disabled={loading}
                  onChange={(obj) => onChangeActionTextSpa(obj)}
                  value={promoEmail.actionButtonTextSpa}
                />
              </div>
              <div
                hidden={promoEmail.template === 0}
                style={{ marginBottom: 10 }}
              >
                <strong>{t('action_button_english')}</strong>
                <Input
                  disabled={loading}
                  onChange={(obj) => onChangeActionTextEng(obj)}
                  value={promoEmail.actionButtonTextEng}
                />
              </div>
              <div
                hidden={promoEmail.template === 0}
                style={{ marginBottom: 10 }}
              >
                <strong>Action Url</strong>
                <Input
                  disabled={loading}
                  onChange={(obj) => onChangeAction(obj)}
                  value={promoEmail.action}
                />
              </div>
            </Panel>
            <Panel header="Images" key="3">
              <Collapse defaultActiveKey={['header']}>
                <Panel header="Header" key="header">
                  <div style={{ marginBottom: 10 }}>
                    <Tooltip title={t('image_requirements')}>
                      <strong>{t('english_image')}:</strong>
                    </Tooltip>
                    <Input
                      className="w-full"
                      disabled={loading}
                      loading={loading}
                      value={promoEmail.headerImageUrlEng}
                      onChange={(obj) => {
                        const temp = JSON.parse(JSON.stringify(promoEmail));
                        temp.headerImageUrlEng = obj.target.value;
                        setPromoEmail(temp);
                      }}
                    />
                    <Dragger {...englishHeaderDraggerProps}>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p
                        className="ant-upload-text"
                        style={{ margin: 10 }}
                      >
                        {t('click_or_drag_content')}
                      </p>
                    </Dragger>
                    {promoEmail.headerImageUrlEng && (
                      <>
                        <Image
                          alt={promoEmail.headerImageUrlEng}
                          src={promoEmail.headerImageUrlEng}
                          height={75}
                        />
                        <Button
                          disabled={loading}
                          type="primary"
                          danger
                          onClick={() => { removeEnlgishHeaderImage(); }}
                        >
                          <CloseOutlined />
                        </Button>
                      </>
                    )}
                  </div>
                  <div style={{ marginBottom: 10 }}>
                    <Tooltip title={t('image_requirements')}>
                      <strong>Spanish Image:</strong>
                    </Tooltip>
                    <Input
                      className="w-full"
                      disabled={loading}
                      loading={loading}
                      value={promoEmail.headerImageUrlSpa}
                      onChange={(obj) => {
                        const temp = JSON.parse(JSON.stringify(promoEmail));
                        temp.headerImageUrlSpa = obj.target.value;
                        setPromoEmail(temp);
                      }}
                    />
                    <Dragger {...spanishHeaderDraggerProps}>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p
                        className="ant-upload-text"
                        style={{ margin: 10 }}
                      >
                        {t('click_or_drag_content')}
                      </p>
                    </Dragger>
                    {promoEmail.headerImageUrlSpa && (
                      <>
                        <Image
                          alt={promoEmail.headerImageUrlSpa}
                          src={promoEmail.headerImageUrlSpa}
                          height={75}
                        />
                        <Button
                          disabled={loading}
                          type="primary"
                          danger
                          onClick={() => { removeSpanishHeaderImage(); }}
                        >
                          <CloseOutlined />
                        </Button>
                      </>
                    )}
                  </div>
                </Panel>
                <Panel header="Main" key="main">
                  <div style={{ marginBottom: 10 }}>
                    <Tooltip title={t('image_requirements')}>
                      <strong>{t('english_image')}:</strong>
                    </Tooltip>
                    <Input
                      className="w-full"
                      disabled={loading}
                      loading={loading}
                      value={promoEmail.imageUrlEng}
                      onChange={(obj) => {
                        const temp = JSON.parse(JSON.stringify(promoEmail));
                        temp.imageUrlEng = obj.target.value;
                        setPromoEmail(temp);
                      }}
                    />
                    <Dragger {...englishMainDraggerProps}>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p
                        className="ant-upload-text"
                        style={{ margin: 10 }}
                      >
                        {t('click_or_drag_content')}
                      </p>
                    </Dragger>
                    {promoEmail.imageUrlEng && (
                      <>
                        <Image
                          alt={promoEmail.imageUrlEng}
                          src={promoEmail.imageUrlEng}
                          height={75}
                        />
                        <Button
                          disabled={loading}
                          type="primary"
                          danger
                          onClick={() => { removeEnlgishMainImage(); }}
                        >
                          <CloseOutlined />
                        </Button>
                      </>
                    )}
                  </div>
                  <div style={{ marginBottom: 10 }}>
                    <Tooltip title={t('image_requirements')}>
                      <strong>{t('spanish_image')}:</strong>
                    </Tooltip>
                    <Input
                      className="w-full"
                      disabled={loading}
                      loading={loading}
                      value={promoEmail.imageUrlSpa}
                      onChange={(obj) => {
                        const temp = JSON.parse(JSON.stringify(promoEmail));
                        temp.imageUrlSpa = obj.target.value;
                        setPromoEmail(temp);
                      }}
                    />
                    <Dragger {...spanishMainDraggerProps}>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p
                        className="ant-upload-text"
                        style={{ margin: 10 }}
                      >
                        {t('click_or_drag_content')}
                      </p>
                    </Dragger>
                    {promoEmail.imageUrlSpa && (
                      <>
                        <Image
                          alt={promoEmail.imageUrlSpa}
                          src={promoEmail.imageUrlSpa}
                          height={75}
                        />
                        <Button
                          disabled={loading}
                          type="primary"
                          danger
                          onClick={() => { removeSpanishMainImage(); }}
                        >
                          <CloseOutlined />
                        </Button>
                      </>
                    )}
                  </div>
                </Panel>
                <Panel header="Footer" key="footer">
                  <div style={{ marginBottom: 10 }}>
                    <Tooltip title={t('image_requirements')}>
                      <strong>{t('english_image')}:</strong>
                    </Tooltip>
                    <Input
                      className="w-full"
                      disabled={loading}
                      loading={loading}
                      value={promoEmail.footerImageUrlEng}
                      onChange={(obj) => {
                        const temp = JSON.parse(JSON.stringify(promoEmail));
                        temp.footerImageUrlEng = obj.target.value;
                        setPromoEmail(temp);
                      }}
                    />
                    <Dragger {...englishFooterDraggerProps}>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p
                        className="ant-upload-text"
                        style={{ margin: 10 }}
                      >
                        {t('click_or_drag_content')}
                      </p>
                    </Dragger>
                    {promoEmail.footerImageUrlEng && (
                      <>
                        <Image
                          alt={promoEmail.footerImageUrlEng}
                          src={promoEmail.footerImageUrlEng}
                          height={75}
                        />
                        <Button
                          disabled={loading}
                          type="primary"
                          danger
                          onClick={() => { removeEnlgishFooterImage(); }}
                        >
                          <CloseOutlined />
                        </Button>
                      </>
                    )}
                  </div>
                  <div style={{ marginBottom: 10 }}>
                    <Tooltip title={t('image_requirements')}>
                      <strong>{t('spanish_image')}:</strong>
                    </Tooltip>
                    <Input
                      className="w-full"
                      disabled={loading}
                      loading={loading}
                      value={promoEmail.footerImageUrlSpa}
                      onChange={(obj) => {
                        const temp = JSON.parse(JSON.stringify(promoEmail));
                        temp.footerImageUrlSpa = obj.target.value;
                        setPromoEmail(temp);
                      }}
                    />
                    <Dragger {...spanishFooterDraggerProps}>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p
                        className="ant-upload-text"
                        style={{ margin: 10 }}
                      >
                        {t('click_or_drag_image')}
                      </p>
                    </Dragger>
                    {promoEmail.footerImageUrlSpa && (
                      <>
                        <Image
                          alt={promoEmail.footerImageUrlSpa}
                          src={promoEmail.footerImageUrlSpa}
                          height={75}
                        />
                        <Button
                          disabled={loading}
                          type="primary"
                          danger
                          onClick={() => { removeSpanishFooterImage(); }}
                        >
                          <CloseOutlined />
                        </Button>
                      </>
                    )}
                  </div>
                </Panel>
              </Collapse>
            </Panel>
          </Collapse>
          <div
            style={{
              float: 'right',
              marginTop: '10px'
            }}
          >
            <Button
              style={{
                marginLeft: '10px'
              }}
              disabled={loading}
              type="primary"
              onClick={() => { submitPromoEmail(); }}
            >
              {promoEmail.id ? t('update') : t('create')}
            </Button>
          </div>
        </>
      )}
    </Drawer>
  );
}

export default EditPromoEmailDrawer;
